var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright",class:_vm.backflag?'bg':''},[_c('div',[_vm._v("© 2017-2022 Hikoon Copyright 版权所有")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"margintop"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("京ICP备 17046250号")]),_vm._v(" | 京公网安备 11011202000841号")])
}]

export { render, staticRenderFns }